import { Routes } from "@angular/router";
import { RoleGuard } from "../../core/guards/role/role.guard";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { MultiLedgerAssociationComponent } from "./multi-ledger-association/multi-ledger-association.component";

export const multiLedgerRoutes: Routes = [
  {
    path: "",
    canActivate: [RoleGuard],
    data: {
      roles: [UserRole.Admin],
    },
    component: MultiLedgerAssociationComponent,
  },
];
